import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45db_45global from "/usr/src/app/src/middleware/01.db.global.ts";
import _02_45auth_45global from "/usr/src/app/src/middleware/02.auth.global.ts";
import _03_45redirect_45trailing_45slash_45global from "/usr/src/app/src/middleware/03.redirect-trailing-slash.global.ts";
import _04_45feature_45flags_45redirect_45global from "/usr/src/app/src/middleware/04.feature-flags-redirect.global.ts";
import _05_45orientation_45global from "/usr/src/app/src/middleware/05.orientation.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45db_45global,
  _02_45auth_45global,
  _03_45redirect_45trailing_45slash_45global,
  _04_45feature_45flags_45redirect_45global,
  _05_45orientation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "debug-redirect-home": () => import("/usr/src/app/src/middleware/debug-redirect-home.ts"),
  "featureflag-redirect-dailyquiz": () => import("/usr/src/app/src/middleware/featureflag-redirect-dailyquiz.ts"),
  "featureflag-redirect-gradesimulator": () => import("/usr/src/app/src/middleware/featureflag-redirect-gradesimulator.ts"),
  "marine-redirect-welcome": () => import("/usr/src/app/src/middleware/marine-redirect-welcome.ts"),
  "parent-redirect-adventure": () => import("/usr/src/app/src/middleware/parent-redirect-adventure.ts"),
  "parent-redirect-firstchild": () => import("/usr/src/app/src/middleware/parent-redirect-firstchild.ts"),
  "parent-redirect-home": () => import("/usr/src/app/src/middleware/parent-redirect-home.ts")
}